import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import { useNavigate } from "react-router-dom";

const TESTIMONIALS = [
  {
    id: 1,
    name: "Odile Servy",
    location: "France",
    trek: "Multiple Treks with Sherpa Trekker",
    rating: 5,
    avatar: "/assets/images/odile-servy.jpeg",
    image: "/assets/images/odile-servy.jpeg",
    quote:
      "I have made several trek with Sherpatrekker! Five! Because I enjoyed so much the first one with Sherpatrekker that I would come again! Nepal is an enchanting country and all the trek I made with Sherpatrekker has been amazing! Pasang Sherpa the guide, is a true professional! His team too! Only good surprise with them! Discover new paths, meet the locals, their way of life and share special moments with them, always feel well supported, discover the flora and fauna, Sherpatrekker brings all that! Trek with Sherpatrekker is really a great experience full of unforgettable moments! I dream to go again trekking with Sherpatrekker and I thank very much Pasang Sherpa and his team for bringing me so much emotion during my holidays in Nepal!",
    transformation: "From first-time trekker to lifelong adventurer returning five times",
    highlights: [
      "Completed 5 treks with Sherpa Trekker",
      "Discovered new paths and local culture",
      "Always felt well supported",
      "Deep connection with nature and people",
    ],
    date: "2024",
    duration: "Multiple Treks",
  },
  {
    id: 2,
    name: "Aurély & Family",
    location: "France",
    trek: "Langtang Trek",
    rating: 5,
    avatar: "/assets/images/aurely-family.jpeg",
    image: "/assets/images/aurely-family.jpeg",
    quote:
      "Thank you Sherpa Trekker for organizing this trip. It was a pleasure to meet you: Sanu, Pemba, Pasang's family, Fireman, Mama from the Garden Inn hotel, Maya, Khrishna and all the others. Thank you all for your smiles, your sharing, your joy, your welcome. We had a very nice trip among you. Thank you for all.",
    transformation: "A family journey filled with warmth and connection",
    highlights: [
      "Met Pasang's family and local community",
      "Experienced warm Sherpa hospitality",
      "Beautiful Langtang trek experience",
      "Unforgettable family adventure",
    ],
    date: "2024",
    duration: "Langtang Trek",
  },
  {
    id: 3,
    name: "Luigi",
    location: "Italy",
    trek: "Annapurna Circuit Trek",
    rating: 5,
    avatar: "/assets/images/luigi.jpeg",
    image: "/assets/images/luigi.jpeg",
    quote:
      "Pasang Sherpa is a very good trekking guide, who knows his business. Nothing to complain. I felt safe and well-protected with him during the entire trek. He has great knowledge of his country. He told me what to eat and what not and why. He showed me things that I would never seen without him. I am more than satisfied with his great service. Anytime again with him. It was very useful to get a big travel bag and map!",
    transformation: "From satisfied trekker to loyal returning client",
    highlights: [
      "Felt safe and well-protected throughout",
      "Learned about local food and culture",
      "Discovered hidden gems off the beaten path",
      "Highly recommends Pasang's guiding service",
    ],
    date: "2024",
    duration: "Annapurna Circuit",
  },
  {
    id: 4,
    name: "Markus Balmer",
    location: "Switzerland",
    trek: "Ghorepani Poonhill · Pikey Peak · Langtang Valley",
    rating: 5,
    avatar: "/assets/images/markus-balmer.jpeg",
    image: "/assets/images/markus-balmer.jpeg",
    quote:
      "I booked three treks with 'Sherpatrekker': the first was the Ghorepani Poonhill trek, followed by a climb of Pikey Peak where I experienced the sunrise with a view of Everest, and finally a trek in the Langtang Valley. Along with his meticulous planning and sense of responsibility, the good humour of Pasang and his team ensured an unforgettable trek.",
    transformation: "From first-time trekker to returning adventurer across three Himalayan journeys",
    highlights: [
      "Completed 3 treks with Sherpa Trekker",
      "Witnessed Everest sunrise from Pikey Peak",
      "Explored Ghorepani Poonhill and Langtang Valley",
      "Highly recommends Pasang's planning and humour",
    ],
    date: "2016",
    duration: "Multiple Treks",
  },
  {
    id: 5,
    name: "Myrta Fink",
    location: "Germany",
    trek: "Tailored Himalayan Treks",
    rating: 5,
    avatar: "/assets/images/myrta-fink.jpeg",
    image: "/assets/images/myrta-fink.jpeg",
    quote:
      "Sherpatrekker is an excellent choice. It takes every request into account; the boss and Guide Pasang Sherpa is a very friendly and caring person. He organises the treks to perfection, and changes are no problem at all. You're treated like royalty, and he treats his team exceptionally well too. If a problem arises, we'll look for the best possible solution and act on it; the price includes everything from full board to a hot shower or a beer in the evening, if possible. The trekking route can be tailored to your preferences; it's definitely worth hiking through this beautiful mountainous region with Pasang and his team. Whether in spring or autumn – each season has its own charm. A trekking with Pasang and his people is an enriching and unforgettable experience. It provides an insight into Nepalese culture and the simple way of life of the mountain people. 🌺🪷💖 Have a wonderful day",
    transformation: "From guest to royalty — an enriching journey into Nepalese culture and mountain life",
    highlights: [
      "Every request taken into account",
      "Treks organised to perfection with flexible changes",
      "Treated like royalty with everything included",
      "Insight into Nepalese culture and mountain life",
    ],
    date: "2026",
    duration: "Tailored Treks",
  },
];

const TestimonialSection = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setCurrent((c) => (c + 1) % TESTIMONIALS.length), 7000);
    return () => clearInterval(t);
  }, []);

  const t = TESTIMONIALS[current];

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-secondary/10 text-secondary text-sm font-semibold rounded-full mb-4">
            <Icon name="Star" size={14} className="fill-current" />
            Traveler Stories
          </span>
          <h2 className="section-heading text-foreground mb-4">
            <span style={{ color: "#c4873a" }}>Transformation</span> Stories
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Every trek is a journey of personal transformation. Hear from adventurers who discovered new versions of themselves in the Himalayas.
          </p>
        </div>

        {/* Main card */}
        <div className="bg-gray-50 rounded-3xl overflow-hidden shadow-sm border border-gray-100">
          <div className="grid lg:grid-cols-5">

            {/* Image panel */}
            <div className="lg:col-span-2 relative min-h-72 lg:min-h-0">
              <img
                src={t.image}
                alt={t.trek}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-black/60 via-black/20 to-transparent" />
              {/* Trek badge */}
              <div className="absolute top-5 left-5 flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 rounded-xl px-3 py-1.5">
                <Icon name="MapPin" size={13} className="text-white" />
                <span className="text-white text-sm font-medium">{t.trek}</span>
              </div>
              {/* Duration */}
              <div className="absolute bottom-5 left-5 flex items-center gap-2 bg-primary/90 backdrop-blur-sm rounded-xl px-3 py-1.5">
                <Icon name="Clock" size={13} className="text-white" />
                <span className="text-white text-sm font-medium">{t.duration}</span>
              </div>
            </div>

            {/* Content panel */}
            <div className="lg:col-span-3 p-7 lg:p-10 flex flex-col">

              {/* Reviewer */}
              <div className="flex items-center gap-4 mb-6">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-14 h-14 rounded-full object-cover ring-2 ring-primary/20"
                />
                <div>
                  <p className="font-headline font-bold text-foreground">{t.name}</p>
                  <p className="text-sm text-text-secondary">{t.location} · {t.date}</p>
                  <div className="flex gap-0.5 mt-1">
                    {[...Array(t.rating)].map((_, i) => (
                      <Icon key={i} name="Star" size={13} className="text-sunrise-gold fill-current" />
                    ))}
                  </div>
                </div>
              </div>

              {/* Quote */}
              <blockquote className="mb-6">
                <Icon name="Quote" size={28} className="text-primary/20 mb-3" />
                <p className="text-gray-700 text-lg leading-relaxed italic">
                  "{t.quote}"
                </p>
              </blockquote>

              {/* Transformation */}
              <div className="flex items-start gap-3 p-4 bg-primary/5 rounded-xl border-l-4 border-primary mb-6">
                <Icon name="Sparkles" size={16} className="text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-xs font-semibold text-primary uppercase tracking-wide mb-0.5">Personal Transformation</p>
                  <p className="text-sm text-gray-700">{t.transformation}</p>
                </div>
              </div>

              {/* Highlights */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-8">
                {t.highlights.map((h, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                      <Icon name="Check" size={11} className="text-green-600" />
                    </span>
                    <span className="text-sm text-gray-600">{h}</span>
                  </div>
                ))}
              </div>

              {/* CTAs */}
              <div className="flex flex-col sm:flex-row gap-3 mt-auto">
                <button
                  onClick={() => navigate("/booking-consultation-center")}
                  className="flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white font-semibold rounded-xl hover:bg-primary/90 transition-colors text-sm"
                >
                  <Icon name="Calendar" size={15} />
                  Start Your Journey
                </button>
                <button
                  onClick={() => navigate("/traveler-stories-hub")}
                  className="flex items-center justify-center gap-2 px-6 py-3 border-2 border-gray-200 text-gray-700 font-semibold rounded-xl hover:border-primary hover:text-primary transition-colors text-sm"
                >
                  <Icon name="BookOpen" size={15} />
                  Read More Stories
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Dot navigation + mini cards */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Dots */}
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`rounded-full transition-all duration-300 ${
                  i === current ? "w-8 h-3 bg-primary" : "w-3 h-3 bg-gray-200 hover:bg-primary/40"
                }`}
              />
            ))}
          </div>

          {/* Mini reviewer cards */}
          <div className="flex gap-3">
            {TESTIMONIALS.map((item, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`flex items-center gap-2 px-3 py-2 rounded-xl border transition-all duration-200 ${
                  i === current
                    ? "border-primary bg-primary/5 shadow-sm"
                    : "border-gray-200 hover:border-primary/40 bg-white"
                }`}
              >
                <img src={item.avatar} alt={item.name} className="w-7 h-7 rounded-full object-cover" />
                <span className={`text-xs font-medium hidden sm:block ${i === current ? "text-primary" : "text-gray-500"}`}>
                  {item.name.split(" ")[0]}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
